<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("edit") }} {{ $t("voucher") }}</div>
      <router-link class="btn-blue" to="vouchers"
        >{{ $t("voucher") }} {{ $tc("list") }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="new-border rounded-10 p-3 mb-4 back">
        <div class="row">
          <div class="col-lg-4 col-xl-3 mb-0">
            <div class="input-material">
              <input
                disabled
                v-model="vouchersObject.voucher_code"
                v-validate="{ required: 'required' }"
                name="voucher_code"
                id="voucher_code"
                placeholder="."
                type="text"
              />
              <label>{{ $t("code") }}</label>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_code')">{{
                errors.first("voucher_code")
              }}</span>
            </p>
          </div>

          <div class="col-lg-4 col-xl-3 mb-0">
            <div class="input-material">
              <input
                v-model="vouchersObject.voucher_title"
                v-validate="'required'"
                name="voucher_title"
                id="voucher_title"
                placeholder="."
                type="text"
              />
              <label>{{ $t("name") }}</label>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_title')">{{
                errors.first("voucher_title")
              }}</span>
            </p>
          </div>
          <div class="col-lg-4 col-xl-3 mb-0">
            <div class="input-material d-flex align-items-center">
              <input
                v-model="vouchersObject.voucher_receipt_name"
                name="voucher_receipt_name"
                id="voucher_receipt_name"
                placeholder="."
                type="text"
                v-b-tooltip.hover
                :title="$t('info')"
              />
              <label>{{ $t("Receipt") }} {{ $t("inprint") }}</label>
              <!--Tooltip :title="$t('info')" /-->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_receipt_name')">{{
                errors.first("voucher_receipt_name")
              }}</span>
            </p>
          </div>

          <!---Active Button-->
          <div class="col-lg-3 col-xl-3 align-self-center mb-4">
            <div class="d-flex align-items-center justify-content-center">
              <b-form-checkbox
                class="ml-3 j-checkbox pb-0"
                v-model="vouchersObject.voucher_is_active"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">{{
                vouchersObject.voucher_is_active === "Y" ? "Active" : "Deactive"
              }}</span>
            </div>
          </div>
          <!---Active Button-->
        </div>

        <div :class="['my-3', 'col-lg-12 col-xl-12']">
          <div class="d-flex align-self-center">
            <strong>1.&nbsp;</strong>
            <b-form-checkbox
              class="j-checkbox pb-0 ml-3"
              v-model="vouchersObject.voucher_for_specific_seat_type"
              @change="(event) => onChangeCinemaSpecificValue(event)"
              unchecked-value="N"
              value="Y"
            ></b-form-checkbox>
            <div>
              {{ $t("applicableforselectedcinemasclassesntickettypes") }}
            </div>
          </div>
          <b-collapse
            :visible="vouchersObject.voucher_for_specific_seat_type === 'Y'"
          >
            <div
              class="pt-2"
              v-if="vouchersObject.voucher_for_specific_seat_type === 'Y'"
            >
              <div
                v-for="(Item, ItemsIndex) in vouchersObject.selectedCinemasList"
                :key="ItemsIndex"
                class="row back_white mb-2 pt-2 mx-1"
              >
                <div class="col-lg-6 col-xl-3 mb-xl-0">
                  <custommultiselect
                    v-model="Item.cine_id"
                    :options="Cinemas"
                    @input="getScreenList($event, null, ItemsIndex)"
                    :placeholder="$tc('Cinemas')"
                    label="cine_name"
                    isSingleId="cine_id"
                    :multiple="false"
                    track-by="cine_id"
                  ></custommultiselect>
                </div>

                <div class="col-lg-6 col-xl-2 mb-xl-0">
                  <custommultiselect
                    v-model="Item.screen_id"
                    :options="Item.screenList"
                    @input="getSeatClassList($event, ItemsIndex)"
                    :placeholder="$tc('screens')"
                    label="screen_name"
                    isSingleId="screen_id"
                    :multiple="false"
                    track-by="screen_id"
                  ></custommultiselect>
                </div>

                <div class="col-lg-6 col-xl-3">
                  <custommultiselect
                    v-model="Item.sst_id"
                    :options="Item.seatClassList"
                    :placeholder="$tc('Seat Class')"
                    label="sst_seat_type"
                    isSingleId="sst_id"
                    :multiple="false"
                    track-by="sst_id"
                  ></custommultiselect>
                </div>
                <!-- SELECT TICKET TYPE -->
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <custommultiselect
                      v-model="Item.tt_id"
                      :options="TicketTypes"
                      label="tt_name"
                      track-by="tt_id"
                      isSingleId="tt_id"
                      :placeholder="$tc('TicketType')"
                      :multiple="false"
                      v-b-tooltip.hover
                      :title="$t('selectTicketType')"
                    />
                  </div>
                </div>
                <div class="col-xl-1">
                  <!-- <button
                      v-if="ItemsIndex == 0"
                      class="btn-transparent mb-3"
                      @click="addMoreCinemasScreenSeatClass()"
                    >
                      <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
                    </button> -->

                  <button
                    class="btn-transparent mb-3"
                    @click="removeCinemasScreenSeatClass(ItemsIndex)"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="35"
                      width="35"
                    />
                  </button>
                </div>
              </div>
              <div
                class="row d-flex align-items-center justify-content-center border-top mt-4 mb-5 position-relative"
              >
                <button
                  @click.prevent.stop="addMoreCinemasScreenSeatClass()"
                  class="btn-transparent add-more-button"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>
          </b-collapse>
        </div>

        <div class="row">
          <div
            v-if="vouchersObject.voucher_for_specific_seat_type === 'N'"
            :class="[
              'mb-1',
              cinemasList.length > 0 &&
              cinemasList[0].Cinemas.length > 0 &&
              cinemasList[0].Cinemas.length ===
                vouchersObject.selectedCinemasList.length
                ? 'col-lg-12 col-xl-12'
                : 'col-lg-6 col-xl-4',
            ]"
          >
            <div class="dropdown-curve-container">
              <div class="multiselect">
                <custommultiselect
                  v-model="vouchersObject.selectedCinemasList"
                  :options="cinemasList"
                  :placeholder="$tc('selectCinemas')"
                  label="cine_name"
                  :multiple="true"
                  track-by="cine_id"
                  group-values="Cinemas"
                  group-label="label"
                  :group-select="true"
                >
                  <!-- <template slot="tag" slot-scope="{ option }">
                  <span>{{ option.cine_name }},&nbsp;</span>
                </template> -->
                </custommultiselect>
              </div>
            </div>
            <p class="error_message">
              <span
                v-if="
                  submitted && vouchersObject.selectedCinemasList.length == 0
                "
                >{{ $tc("select_user_Cinema") }}.</span
              >
            </p>
          </div>
        </div>

        <div class="row ">
          <div class="col-lg-6 col-xl-6 align-self-center mb-1">
            <div class="input-material-textarea">
              <textarea
                v-model="vouchersObject.voucher_description"
                rows="3"
              ></textarea>
              <label>{{ $t("voucher") }} {{ $t("usedfor") }}</label>
            </div>
            <p class="error_message"></p>
          </div>

          <div
            :class="[
              'mb-1',
              movieList.length > 0 &&
              movieList[0].Movies.length &&
              movieList[0].Movies.length ===
                vouchersObject.selectedMoviesList.length
                ? 'col-lg-6 col-xl-6'
                : 'col-lg-6 col-xl-6',
            ]"
          >
            <div class="dropdown-curve-container">
              <custommultiselect
                v-model="vouchersObject.selectedMoviesList"
                :options="movieList"
                :placeholder="$tc('movies')"
                label="movie"
                isSingleId="md_id"
                :multiple="true"
                track-by="md_id"
                group-values="Movies"
                group-label="label"
                :group-select="true"
                @remove="removedMovie"
              >
                <!-- <template slot="tag" slot-scope="{ option }">
                <span>{{ option.movie }},&nbsp;</span>
              </template> -->
              </custommultiselect>
            </div>
            <p class="error_message">
              <!-- v-if="submitted && vouchersObject.selectedMoviesList.length == 0" -->
              <span></span>
            </p>
          </div>
        </div>

        <div class="row " style="height:35px;">
          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button
                  class="btn-clearDate"
                  v-if="vouchersObject.voucher_start_date_time"
                  v-on:click="vouchersObject.voucher_start_date_time = null"
                >
                  ✖
                </button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="vouchersObject.voucher_start_date_time"
                    type="date"
                    class="theme-custom-date-time  w-100"
                    typeable
                    id="voucher_startdate"
                    name="voucher_startdate"
                    v-validate="'required'"
                    :disabled-dates="disabledDates"
                    v-b-tooltip.hover
                    :title="$t('voucher_start_date_tooltip')"
                  ></Datepicker>
                  <!--Tooltip :title="$t('voucher_start_date_tooltip')" /-->
                </div>
                <label
                  :class="
                    vouchersObject.voucher_start_date_time ? 'active' : ''
                  "
                  >{{ $t("startdate") }}</label
                >
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_startdate')">{{
                errors.first("voucher_startdate")
              }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button
                  class="btn-clearDate"
                  v-if="vouchersObject.voucher_end_date_time"
                  v-on:click="vouchersObject.voucher_end_date_time = null"
                >
                  ✖
                </button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="vouchersObject.voucher_end_date_time"
                    type="date"
                    class="theme-custom-date-time  w-100"
                    typeable
                    id="voucher_enddate"
                    name="voucher_enddate"
                    @selected="onSelectEndDateVoucher($event)"
                    v-b-tooltip.hover
                    :title="$t('voucher_end_date_tooltip')"
                  ></Datepicker>
                  <!--Tooltip :title="$t('voucher_end_date_tooltip')" /-->
                </div>
                <label
                  :class="vouchersObject.voucher_end_date_time ? 'active' : ''"
                  >{{ $t("enddate") }}</label
                >
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('voucher_enddate')">{{
                errors.first("voucher_enddate")
              }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="d-flex justify-content-center align-items-center">
              <vue-timepicker
                manual-input
                v-model="vouchersObject.startTime2"
                id="starttime"
                name="starttime"
                :placeholder="$tc('starttime')"
                format="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                v-b-tooltip.hover
                :title="$t('voucher_start_time')"
              ></vue-timepicker>
              <!--Tooltip :title="$t('voucher_start_time')" /-->
            </div>
            <!-- <div class="input-material">
              <div class="add-datepicker">
                <date-picker
                v-model="vouchersObject.voucher_start_date_time"
                type="time"
                class="theme-custom-date-time"
                format="hh:mm a"
                lang="en"
                :minute-step="1"
                typeable
                v-validate="'required'"
                id="o_start_time"
              ></date-picker>
                <label class="active"
                  >{{ $t("offer") }} {{ $t("starttime") }}</label
                >
              </div>
            </div> -->
            <p class="error_message">
              <span v-if="submitted && errors.has('starttime')">{{
                errors.first("starttime")
              }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 mb-1">
            <div class="d-flex justify-content-center align-items-center">
              <vue-timepicker
                manual-input
                v-model="vouchersObject.endTime2"
                id="endtime"
                name="endtime"
                :placeholder="$tc('endtime')"
                format="HH:mm"
                class="time_picker"
                input-width="100%"
                auto-scroll
                lazy
                v-b-tooltip.hover
                :title="$t('voucher_start_time')"
              ></vue-timepicker>
              <!--Tooltip :title="$t('voucher_start_time')" /-->
            </div>
            <!-- <div class="input-material">
              <div class="add-datepicker">
                <date-picker
                v-model="vouchersObject.voucher_end_date_time"
                type="time"
                class="theme-custom-date-time"
                format="hh:mm a"
                lang="en"
                :minute-step="1"
                typeable
                v-validate="'required'"
                id="o_start_time"
              ></date-picker>
                <label class="active"
                  >{{ $t("offer") }} {{ $t("endtime") }}</label
                >
              </div>
            </div> -->
            <p class="error_message">
              <span v-if="submitted && errors.has('endtime')">{{
                errors.first("endtime")
              }}</span>
            </p>
          </div>
        </div>
        <!-- client_id -->
        <!-- <div class="col-lg-6 col-xl-4 mb-4">
          <multiselect
            v-model="vouchersObject.selectedClient"
            placeholder="Select Client"
            :options="clientList"
            @select="onSelectClient($event)"
            label="client_name"
            track-by="client_id"
            :multiple="false"
          ></multiselect>
        </div>-->

        <!-- <div class="col-lg-6 col-xl-4 mb-4">
          <div class="input-material">
            <input
              v-model="vouchersObject.voucher_receipt_name"
              name="voucher_receipt_name"
              id="voucher_receipt_name"
              placeholder="."
              type="text"
            />
            <label>{{ $t("voucher") }} {{ $t("receipt_name") }}</label>
          </div>
        </div> -->

        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <b-form-checkbox
              class="ml-3"
              v-model="vouchersObject.is_code_required"
              unchecked-value="N"
              value="Y"
              switch
            ></b-form-checkbox>
            <span class="ml-3">{{ $t("Code Required") }}</span>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <b-form-checkbox
              class="ml-3"
              v-model="vouchersObject.is_share_with_distributor"
              unchecked-value="N"
              value="Y"
              switch
            ></b-form-checkbox>
            <span class="ml-3">{{ $t("Share With Distributor") }}</span>
          </div>
        </div> -->
      </div>

      <!---Voucher setting--->
      <div class="rounded-10 p-3 mb-4 new-border back">
        <div class="section-title text-uppercase mb-3" style="font-size: 20px">
          {{ $t("voucher") }} {{ $tc("setting", 2) }}
        </div>

        <div class="row">
          <div class="col-lg-4 col-xl-3 align-self-center mb-1">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="vouchersObject.is_code_required"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">{{ $t("is_code_required") }}</span>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-1">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="vouchersObject.is_open_voucher"
                unchecked-value="N"
                value="Y"
                disabled
                @change="onchangeOpenVoucher($event)"
              ></b-form-checkbox>
              <span class="ml-1">{{ $t("openVoucher") }}</span>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-1">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="vouchersObject.is_share_with_distributor"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">{{ $t("is_share_with_distributor") }}</span>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-1" v-if="false">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="vouchersObject.add_in_revenue"
                unchecked-value="N"
                value="Y"
              ></b-form-checkbox>
              <span class="ml-1">{{ "Add in Revenue" }}</span>
            </div>
          </div>

          <div
            class="col-lg-6 col-xl-3 align-self-center mb-4"
            v-if="vouchersObject.is_open_voucher == 'Y'"
          >
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class="j-checkbox pb-0"
                v-model="vouchersObject.is_complimentary_ticket"
                unchecked-value="N"
                value="Y"
                @change="handleComplimetoryChange"
              ></b-form-checkbox>
              <span class="ml-3">{{ $t("is_complimentary_ticket") }}</span>
            </div>
          </div>

          <div
            class="col-lg-6 col-xl-3 align-self-center mb-4"
            v-if="
              vouchersObject.is_open_voucher == 'Y' &&
                vouchersObject.is_complimentary_ticket == 'N'
            "
          >
            <div class="d-flex align-items-center">
              <b-form-checkbox
                class
                v-model="vouchersObject.is_allow_cash_refund"
                unchecked-value="N"
                value="Y"
                switch
              ></b-form-checkbox>
              <span class="ml-3">{{ $t("allow_cash_refund") }}</span>
            </div>
          </div>

          <div
            class="col-lg-6 col-xl-3 align-self-center mb-4 pt-4"
            v-if="
              vouchersObject.is_open_voucher == 'Y' &&
                vouchersObject.is_complimentary_ticket == 'Y'
            "
          >
            <div class=" d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="vouchersObject.ticket_type_selected ? 'shift-up' : ''"
                  >{{ $tc("ticketType") }}
                </label>
                <multiselect
                  v-model="vouchersObject.ticket_type_selected"
                  @select="selectTicketType($event)"
                  :options="TicketTypes"
                  label="tt_name"
                  track-by="tt_id"
                  placeholder=""
                  :multiple="false"
                  v-b-tooltip.hover
                  :title="$t('Select ticket type')"
                />
              </div>

              <!--Tooltip :title="$t('Select ticket type')" /-->
            </div>
            <p class="error_message">
              <span
                v-if="
                  submitted &&
                    vouchersObject.is_complimentary_ticket == 'Y' &&
                    vouchersObject.ticket_type_selected.length == 0
                "
                >{{ messagetickettype }}</span
              >
            </p>
          </div>

          <div
            class="col-lg-6 col-xl-3 align-self-center mb-5 pt-4"
            v-if="
              !hideComplemetory && vouchersObject.is_complimentary_ticket == 'Y'
            "
          >
            <div class=" d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    vouchersObject.selectedCinemaComplimentory ? 'shift-up' : ''
                  "
                  >{{ "Cinema" }}</label
                >
                <multiselect
                  v-model="vouchersObject.selectedCinemaComplimentory"
                  @select="onSelectComplimetoryCinema($event)"
                  @remove="onRemoveComplimetoryCinema($event)"
                  :options="Cinemas"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder=""
                  :multiple="false"
                  v-b-tooltip.hover
                  :title="$t('Cinema')"
                />
              </div>

              <!--Tooltip :title="$t('Cinema')" /--->
            </div>
          </div>

          <div
            class="col-lg-6 col-xl-3 align-self-center mb-5"
            v-if="
              !hideComplemetory &&
                vouchersObject.is_complimentary_ticket == 'Y' &&
                vouchersObject.selectedCinemaComplimentory
            "
          >
            <div class=" d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="vouchersObject.selectedScreen ? 'shift-up' : ''"
                  >{{ $tc("screen", 1) }}</label
                >
                <multiselect
                  v-model="vouchersObject.selectedScreen"
                  @select="onSelectScreen($event)"
                  @remove="onRemoveScreen($event)"
                  :options="ScreenList"
                  label="screen_name"
                  track-by="screen_id"
                  placeholder=""
                  :multiple="false"
                  v-b-tooltip.hover
                  :title="$t('Screen')"
                />
              </div>

              <!--Tooltip :title="$t('Screen')" /-->
            </div>
          </div>
        </div>
      </div>

      <!---Voucher configuration--->
      <div class="new-border rounded-10 p-3 mb-4 back">
        <div class="section-title text-uppercase mb-4" style="font-size: 20px">
          {{ $t("voucher") }} {{ $tc("configuration", 1) }}
        </div>
        <div class="row" style="align-items:baseline;">
          <div class="col-lg-8 col-xl-8 align-self-center mb-1">
            <div class="row mx-0">
              {{ $t("redeemAt") }}:
              <b-form-checkbox
                v-model="vouchersConfiguration.vs_redeem_at_boxoffice"
                class="j-checkbox mx-3 mb-3 pb-0"
                @change="onChangeReedem()"
              >
                <div class="text-capitalize">{{ $t("boxoffice") }}</div>
              </b-form-checkbox>
              <b-form-checkbox
                :disabled="isValueVoucher == 'N'"
                v-model="vouchersConfiguration.vs_redeem_at_concession"
                class="j-checkbox mx-3 mb-3 pb-0"
                @change="onChangeReedem()"
              >
                <div class="text-capitalize">{{ $t("concession") }}</div>
                <span class="text-muted fs-12">{{
                  isValueVoucher == "N" ? "(Not Applicable)" : ""
                }}</span>
              </b-form-checkbox>
              <b-form-checkbox
                v-if="vouchersObject.is_open_voucher != 'Y'"
                v-model="vouchersConfiguration.vs_redeem_at_online"
                class="j-checkbox mx-3 mb-3 pb-0"
                @change="onChangeReedem()"
              >
                <div class="text-capitalize">{{ $t("online") }}</div>
              </b-form-checkbox>
            </div>
            <p class="error_message" style="margin-top:2px">
              <span>{{ $t(reedemerror) }}</span>
            </p>
          </div>

          <div
            class="d-flex align-items-center mb-3 col-lg-4 col-xl-4 justify-content-center"
            v-if="showConfiguration"
          >
            <span>{{ $t("isValueVoucher") }}</span>
            <b-form-checkbox
              class="j-checkbox ml-3 pb-0"
              v-model="isValueVoucher"
              @change="onChangeSwitch($event)"
              unchecked-value="N"
              value="Y"
            ></b-form-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="internal-border" style="background-color:white">
            <div
              v-if="isValueVoucher == 'N' && showConfiguration"
              class="col-lg-6 col-xl-4 align-self-center mb-1"
            >
              {{ $t("buyngetfreeticket") }}
              <div
                class="offer-content-wrapper"
                style="padding-left:0px;padding-top:15px"
              >
                <div class="row">
                  <div class="col-lg-12 col-xl-12 mb-3">
                    <div class="d-flex align-items-center">
                      {{ $t("buy") }}
                      <div class="input-material-sm mx-1">
                        <input
                          v-validate="'required|numeric'"
                          name="buy_ticket"
                          v-model="
                            vouchersConfiguration.voucher_buy_no_of_ticket
                          "
                          type="number"
                        />
                      </div>
                      {{ $t("get") }}
                      <div class="input-material-sm mx-2">
                        <input
                          v-validate="'required|numeric'"
                          name="get_ticket"
                          v-model="
                            vouchersConfiguration.voucher_get_free_ticket
                          "
                          type="number"
                        />
                      </div>
                      {{ $t("ofticketsfree") }}
                    </div>
                  </div>
                </div>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('buy_ticket')"
                  >Please enter value for buy ticket</span
                >
                <br />
                <span v-if="submitted && errors.has('get_ticket')"
                  >Please enter value for get ticket</span
                >
              </p>
            </div>

            <!-- VOUCHER VALUE -->
            <div
              v-if="isValueVoucher == 'Y' && showConfiguration"
              class="col-lg-3 col-xl-2 align-self-center mb-2"
            >
              <div class="d-flex align-items-center">
                <span>Value</span>
                <div class="input-material-sm mx-2">
                  <input
                    class="text-right"
                    v-model="vouchersConfiguration.voucher_amount"
                    v-validate="'required|numeric'"
                    name="voucher_amt"
                    id="voucher_amt"
                    type="text"
                  />
                </div>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_amt')">{{
                  errors.first("voucher_amt")
                }}</span>
              </p>
            </div>

            <!-- IS PERCENTAGE -->
            <div
              v-if="isValueVoucher == 'Y' && showConfiguration"
              :class="
                vouchersConfiguration.voucher_is_percentage == 'Y'
                  ? 'col-lg-3 col-xl-2 align-self-center mb-2'
                  : 'col-lg-3 col-xl-3 align-self-center mb-2'
              "
            >
              <div class="d-flex align-items-center">
                <span>{{ $t("Percentage") }}</span>
                <b-form-checkbox
                  class=" j-checkbox ml-3 pb-0"
                  v-model="vouchersConfiguration.voucher_is_percentage"
                  unchecked-value="N"
                  value="Y"
                ></b-form-checkbox>
              </div>
              <p class="error_message"></p>
            </div>

            <!-- MIN BILL AMOUNT  -->
            <div
              class=""
              :class="
                vouchersConfiguration.voucher_is_percentage == 'Y'
                  ? 'col-lg-6 col-xl-5 align-self-center mb-0'
                  : 'col-lg-6 col-xl-7 align-self-center mb-0'
              "
              v-if="showConfiguration"
              :style="isValueVoucher == 'N' ? 'padding-top:15px' : ''"
            >
              <div class="d-flex align-items-center">
                <span>{{ $tc("minBill_Redemption") }}.</span>
                <div class="input-material-sm mx-2">
                  <input
                    class="text-right"
                    v-model="
                      vouchersConfiguration.voucher_min_redemption_amount
                    "
                    v-validate="'required|numeric'"
                    name="voucher_min_amt"
                    id="voucher_min_amt"
                    type="text"
                  />
                </div>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_min_amt')">{{
                  errors.first("voucher_min_amt")
                }}</span>
              </p>
            </div>

            <!-- MAX BILL AMOUNT -->
            <div
              class="col-lg-12 col-xl-3 align-self-center mb-0"
              v-if="
                showConfiguration &&
                  vouchersConfiguration.voucher_is_percentage == 'Y'
              "
              :style="isValueVoucher == 'N' ? 'padding-top:15px' : ''"
            >
              <div class="d-flex align-items-center">
                <span v-if="isValueVoucher == 'Y'"
                  >{{ $tc("Max") }} {{ $tc("discount") }}</span
                >
                <span v-else>{{ $t("maxfreeticketpertransaction") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    class="text-right"
                    v-model="
                      vouchersConfiguration.voucher_max_redemption_amount
                    "
                    name="voucher_max_amt"
                    id="voucher_max_amt"
                    type="text"
                  />
                </div>
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('voucher_max_amt')">{{
                  errors.first("voucher_max_amt")
                }}</span>
              </p>
            </div>
          </div>
          <!-- REDEEMABLE ON NET-VALUE / GROSS AMOUNT  -->
          <div class="col-lg-12 mb-3" v-if="showConfiguration">
            <div class="d-flex align-items-center">
              <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->

              <div>
                <span style="text-transform:capitalize;"
                  >{{ $tc("redeem") }} On :</span
                >
              </div>
              <b-form-radio
                value="voucherRedeemNetAmount"
                class="j-radio ml-2 pb-0"
                v-model="vouchersConfiguration.voucherRedeemAmount"
              >
              </b-form-radio>
              <div>
                <span style="text-transform:capitalize;">{{
                  $tc("netAmount")
                }}</span>
              </div>
              <!--strong class="mx-3">OR</strong-->

              <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
              <b-form-radio
                value="voucherRedeemGrossAmount"
                class="j-radio ml-2 pb-0"
                v-model="vouchersConfiguration.voucherRedeemAmount"
              >
                <div>
                  <span style="text-transform:capitalize;">{{
                    $tc("grossAmount")
                  }}</span>
                </div>
              </b-form-radio>
            </div>
          </div>

          <div class="row col-12" style="margin-left:1px">
            <div class="align-self-center mb-4">
              <div class="d-flex align-items-center">
                <span>{{ $tc("voucherRedemptionperPatron") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    class="text-right"
                    v-model="
                      vouchersConfiguration.voucher_redemption_per_patron
                    "
                    type="number"
                  />
                </div>
              </div>
            </div>

            <div class="align-self-center mb-4">
              <div class="d-flex align-items-center">
                <span>Total {{ $tc("redemption") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    class="text-right"
                    v-model="vouchersConfiguration.voucher_total_redemption"
                    type="number"
                  />
                </div>
              </div>
            </div>

            <div class="align-self-center mb-4" v-if="showConfiguration">
              <div class="d-flex align-items-center">
                <span>{{ $tc("voucherRedemptionPercentageAtFNB") }}</span>
                <div class="input-material-sm mx-2">
                  <input
                    class="text-right"
                    v-model="vouchersObject.voucher_redemption_percent_fnb"
                    type="number"
                    :min="0"
                    :max="100"
                  />
                </div>
                %
              </div>
            </div>
          </div>

          <div class="col-lg-12 col-xl-12 align-self-center mb-1 back">
            <div
              class="row mx-0 internal-border-new rounded-10 px-2 pt-2"
              style="background-color:white"
            >
              Show {{ $t("days") }}:
              <b-form-checkbox
                v-for="(weekdaysLoop, weekdaysKey) in weekDays"
                :key="weekdaysKey"
                v-model="weekDays[weekdaysKey]"
                class="j-checkbox mx-2 mb-2 pb-0"
                @change="onChangeWeekdays($event, weekdaysKey)"
              >
                <div class="text-capitalize">{{ weekdaysKey }}</div>
              </b-form-checkbox>
            </div>
            <p class="error_message" style="margin-top:4px">
              <span>{{ $t(weekdayerror) }}</span>
            </p>
          </div>

          <!-- <div class="col-lg-12 col-xl-12 align-self-center mb-3">
            <div class="row mx-0">
              {{ $t("applicablefor") }}:
              <b-form-checkbox
                v-for="(applicable, applicableForKey) in applicableFor"
                :key="applicableForKey"
                v-model="applicableFor[applicableForKey]"
                class="j-checkbox mx-3 mb-3"
                @change="onChangeApplicable($event, applicableForKey)"
              >
                <div class="text-capitalize">{{ applicableForKey }}</div>
              </b-form-checkbox>
            </div>
            <p class="error_message">
              <span>{{ $t(applicableerror) }}</span>
            </p>
          </div> -->

          <div
            class="col-lg-12 col-xl-6 align-self-center mb-4"
            v-if="showConfiguration"
          >
            <div class="row mx-0">
              {{ $t("vouchersissuedbypartnername") }} :
              <div class="dropdown-curve-container">
                <custommultiselect
                  v-model="vouchersConfiguration.vp_id"
                  :options="voucherPartnerList"
                  :placeholder="$tc('partner')"
                  label="vp_partner_name"
                  isSingleId="vp_id"
                  :multiple="false"
                  track-by="vp_id"
                ></custommultiselect>
              </div>
            </div>
          </div>

          <div class="col-lg-12 col-xl-6">
            <div class="d-flex">
              <div class="input-material-textarea">
                <textarea
                  v-model="vouchersObject.voucher_terms"
                  v-validate="'required'"
                  name="termsandco"
                  id="termsandco"
                  rows="5"
                  class="rounded-10"
                ></textarea>
                <label class="active">{{ $t("termsandconditions") }}</label>
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('termsandco')">{{
                errors.first("termsandco")
              }}</span>
            </p>
          </div>
        </div>
      </div>

      <div class="new-border rounded-10 p-3 mb-4 back">
        <div class="section-title text-uppercase mb-4" style="font-size: 20px">
          {{ $t("voucher") }} {{ $t("split") }} {{ $tc("configuration", 1) }}
        </div>
        <!-- client_id -->
        <div class="row" style="height:35px">
          <div class="col-lg-6 col-xl-4 mb-1">
            <multiselect
              v-model="vouchersObject.selectedClient"
              :placeholder="$tc('client')"
              :options="clientList"
              @select="onSelectClient($event)"
              label="client_name"
              track-by="client_id"
              :multiple="false"
            ></multiselect>
          </div>
          <div class="col-lg-6 col-xl-4 align-self-center mb-1 ">
            <div class="d-flex align-items-center justify-content-center">
              <span>{{ $tc("share") }} {{ $tc("value") }}</span>
              <div class="input-material-sm mx-2">
                <input
                  class="text-right"
                  v-model="vouchersObject.share_value"
                  v-validate=""
                  name="share_value"
                  id="share_value"
                  type="text"
                />
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('share_value')">{{
                errors.first("share_value")
              }}</span>
            </p>
          </div>

          <!-- IS PERCENTAGE -->
          <div class="col-lg-6 col-xl-4 align-self-center mb-1">
            <div class="d-flex align-items-center justify-content-center">
              <span>{{ $t("isPercentage") }}</span>
              <b-form-checkbox
                class="ml-3 j-checkbox pb-0"
                v-model="vouchersObject.share_is_percentage"
                unchecked-value="N"
                value="Y"
                disabled
              ></b-form-checkbox>
            </div>
            <p class="error_message"></p>
          </div>
        </div>
      </div>

      <div class="col-12 mt-4 text-center">
        <button @click.prevent.stop="OnFinalSubmit" class="btn-blue">
          {{ $t("update") }} {{ $t("voucher") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { generateRandomCode } from "@/helper/collection";
import MasterService from "@/services/MasterService";
import scheduleService from "@/services/scheduleService";
import MovieService from "@/services/MovieService";
import MarketingService from "@/services/MarketingService";
import ClientService from "@/services/ClientService";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: { DatePicker, VueTimepicker },
  data() {
    return {
      // SAIF
      TicketTypes: [],
      messagetickettype: "Please Select Ticket Type",
      isRoleID: true,
      submitted: false,
      cinemasList: [],
      clientList: [],
      movieList: [],
      ScreenList: [],
      Cinemas: [],
      voucherPartnerList: [],
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      vouchersObject: {
        voucher_id: null,
        voucher_code: null, // "VO-" + generateRandomCode(8),
        voucher_title: null,
        voucher_description: null,
        voucher_receipt_name: null,
        is_code_required: "Y",
        add_in_revenue: "N",
        is_share_with_distributor: "N",
        ticket_type_selected: "",
        tt_id: null,
        is_complimentary_ticket: "N",
        is_open_voucher: "N",
        cine_id: null,
        selectedCinemasList: [],
        md_id: null,
        selectedMoviesList: [],
        selectedMovie: null,
        voucher_start_date_time: null, // Start_Date,
        voucher_end_date_time: null, // End_date,
        voucher_terms: null,
        voucher_is_active: "Y",
        client_id: null,
        share_value: null,
        share_is_percentage: "Y",
        selectedClient: [],
        startTime2: "",
        endTime2: "",
        voucher_redemption_percent_fnb: 0,
        selectedCinemaComplimentory: "",
        selectedScreen: "",
        cinema_id: null,
        screen_id: null,
        is_allow_cash_refund: "N",
        voucher_for_specific_seat_type: "N",
      },
      isValueVoucher: "Y",
      vouchersConfiguration: {
        vs_redeem_at_boxoffice: true,
        vs_redeem_at_concession: false,
        vs_redeem_at_online: false,

        voucherPartnerName: null,
        vp_id: null,
        noOfVoucher: null,
        amount: null,
        redemptionStartDateTime: null,
        redemptionEndDateTime: null,

        voucher_amount: null,
        voucher_is_percentage: "Y",
        voucher_buy_no_of_ticket: null,
        voucher_get_free_ticket: null,
        voucher_min_redemption_amount: null,
        voucher_max_redemption_amount: null,
        voucherRedeemAmount: "voucherRedeemGrossAmount",
        voucher_redemption_per_patron: null,
        voucher_total_redemption: null,
      },
      weekDays: {
        Alldays: false,
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
      },

      applicableFor: {
        // all: false,
        prebook: true,
        normal: false,
      },
      weekdayerror: "",
      reedemerror: "",
      applicableerror: "",
      // SAIF
      onMountGotMovies: [],
      removedMovies: [],
      hideComplemetory: false,
      voucher_id: "",
    };
  },
  computed: {
    showConfiguration() {
      if (
        this.vouchersObject.is_open_voucher == "Y" ||
        this.vouchersObject.is_complemetory_ticket == "Y"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {},
  beforeMount() {
    this.getTicketTypeList();
    const { voucher_id } = this.$route.query;
    this.voucher_id = voucher_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (roleid != 3) {
      if (voucher_id) {
        this.getActiveVoucherPartners();
        this.getClientList();
      } else {
        this.$router.go(-1);
      }
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    onChangeCinemaSpecificValue(event) {
      this.vouchersObject.voucher_for_specific_seat_type = event;
      console.log("onChangeCinemaSpecificValue", event);
      this.vouchersObject["selectedCinemasList"] = [];
      if (event == "Y") {
        let tempObj = {
          cine_id: null,
          cine_name: "",
          screen_id: null,
          sst_id: null,
          tt_id: null,
          cinemasList: [],
          screenList: [],
          seatClassList: [],
        };
        this.vouchersObject["selectedCinemasList"].push(tempObj);
        this.$forceUpdate();
        console.log(
          "this.vouchersObject[selectedCinemasList]",
          this.vouchersObject["selectedCinemasList"]
        );
      } else {
        this.vouchersObject["selectedCinemasList"] = [];
      }
    },
    onSelectEndDateVoucher(event) {
      console.log("Event Time", event);
      this.vouchersObject.endTime2 = moment(event).format("HH:mm");
    },
    handleComplimetoryChange(event) {
      console.log("handleComplimetoryChange", event);
      if (event == "N") {
        this.vouchersObject.ticket_type_selected = "";
        this.vouchersObject.selectedCinemaComplimentory = "";
        this.vouchersObject.selectedScreen = "";
        this.vouchersObject.cinema_id = null;
        this.vouchersObject.screen_id = null;
        this.vouchersObject.tt_id = null;
      }
    },
    onRemoveComplimetoryCinema() {
      this.vouchersObject.selectedScreen = "";
      this.vouchersObject.screen_id = null;
      this.vouchersObject.selectedCinemaComplimentory = "";
      this.vouchersObject.cinema_id = null;
      this.ScreenList = [];
    },
    onSelectComplimetoryCinema(cinema) {
      console.log("onSelectComplimetoryCinema", cinema);
      this.vouchersObject.selectedScreen = "";
      this.vouchersObject.screen_id = null;
      this.vouchersObject.selectedCinemaComplimentory = cinema;
      this.vouchersObject.cinema_id = cinema.cine_id;
      let cinemaId = cinema.cine_id;
      this.getScreenList(cinemaId);
    },
    onSelectScreen(screen) {
      this.vouchersObject.selectedScreen = screen;
      this.vouchersObject.screen_id = screen.screen_id;
    },
    onRemoveScreen() {
      this.vouchersObject.selectedScreen = "";
      this.vouchersObject.screen_id = null;
    },
    getScreenList: function(
      cinema_id,
      screenId = null,
      Indexx = null,
      onlyListArray = false
    ) {
      console.log("cinema_id :", cinema_id);
      console.log("Indexx :", Indexx);
      if (Indexx || Indexx == 0) {
        this.vouchersObject["selectedCinemasList"][Indexx].screenList = [];
        this.vouchersObject["selectedCinemasList"][Indexx].seatClassList = [];
        if (!onlyListArray) {
          this.vouchersObject["selectedCinemasList"][Indexx].screen_id = null;
          this.vouchersObject["selectedCinemasList"][Indexx].sst_id = null;
        }
      } else {
        this.ScreenList = [];
      }
      let payload = {
        cinema_id: cinema_id,
      };
      scheduleService
        .GetScreens(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            if (Indexx || Indexx == 0) {
              console.log("Indexx: inside", Indexx);
              this.vouchersObject["selectedCinemasList"][
                Indexx
              ].screenList = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              if (screenId) {
                this.vouchersObject["selectedCinemasList"][
                  Indexx
                ].screen_id = screenId;
              }
            } else {
              this.ScreenList = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );

              if (screenId) {
                this.vouchersObject.screen_id = screenId;
                this.vouchersObject.selectedScreen = data.Records.find(
                  (x) => x.screen_id == screenId
                );
              }
            }
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveScreens :", error);
        });
    },
    getSeatClassList: function(
      screen_id,
      Indexx,
      onlyListArray = false,
      sst_id = null
    ) {
      if (!onlyListArray) {
        this.vouchersObject["selectedCinemasList"][Indexx].sst_id = null;
      }
      this.vouchersObject["selectedCinemasList"][Indexx].seatClassList = [];

      if (screen_id) {
        let payload = {
          tableName: "screen_seat_type",
          screen_id: screen_id,
          sst_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.Records.length > 0) {
                // this.seatClassList = data.Records;
                this.vouchersObject["selectedCinemasList"][
                  Indexx
                ].seatClassList = data.Records;
                if (sst_id) {
                  this.vouchersObject["selectedCinemasList"][
                    Indexx
                  ].sst_id = sst_id;
                }
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError);
      }
    },
    addMoreCinemasScreenSeatClass: function() {
      this.vouchersObject["selectedCinemasList"].push({
        cine_id: null,
        screen_id: null,
        sst_id: null,
        tt_id: null,
        cinemasList: this.cinemasList,
        screenList: [],
        seatClassList: [],
      });
    },
    removeCinemasScreenSeatClass: function(index) {
      this.vouchersObject["selectedCinemasList"].splice(index, 1);
    },
    onchangeOpenVoucher(event) {
      console.log("onchangeOpenVoucher", event);
      if (event == "Y") {
        this.hideComplemetory = false;
        // this.vouchersObject.is_code_required = "Y";
      } else if (event == "N") {
        this.hideComplemetory = true;
      }
    },
    selectTicketType(tt) {
      this.vouchersObject.tt_id = tt.tt_id;
      this.vouchersObject.ticket_type_selected = tt;
      this.$forceUpdate();
    },
    getTicketTypeList: function() {
      this.TicketTypes = [];
      let body = {
        tableName: "ms_ticket_type",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;

          if (data && data.status && data.Records.length > 0) {
            this.TicketTypes = data.Records.filter((x) => {
              return x.tt_is_active == "Y";
            });
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          this.getVoucherDetails(this.voucher_id);
        });
    },
    removedMovie: function(data) {
      if (this.removedMovies && this.removedMovies.length == 0) {
        if (data && data.length > 0) {
          this.removedMovies = data;
        } else {
          this.removedMovies.push(data);
        }
      } else {
        if (data && data.length > 0) {
          this.removedMovies.map((x) => {
            data.map((y) => {
              if (x.movie_id != y.movie_id) {
                this.removedMovies.push(data);
              }
            });
          });
        } else {
          this.removedMovies.filter((x) => {
            if (x.movie_id != data.movie_id) {
              this.removedMovies.push(data);
            }
          });
        }
      }
    },
    // SAIF
    getVoucherDetails: function(voucher_id) {
      MarketingService.GetSingleVoucher({ voucher_id, isEdit: true })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            // console.log("data. :", data.Records);
            if (data.Records.length > 0) {
              let Records = data.Records[0];
              this.setVoucherConfiguration(Records);
              this.vouchersObject = {
                voucher_id: Records.voucher_id,
                voucher_code: Records.voucher_code, // "VO-" + generateRandomCode(8),
                voucher_title: Records.voucher_title,
                voucher_receipt_name: Records.voucher_receipt_name,
                voucher_description: Records.voucher_description,
                is_code_required: Records.is_code_required,
                add_in_revenue: Records.add_in_revenue || "N",
                is_share_with_distributor: Records.is_share_with_distributor,
                is_open_voucher: Records.is_open_voucher,
                is_allow_cash_refund: Records.is_allow_cash_refund,
                is_complimentary_ticket: Records.is_complemetory_ticket,
                tt_id: Records.tt_id,
                client_id: Records.client_id,
                share_value: Records.client_share_value || null,
                share_is_percentage: Records.client_share_is_percentage || "Y",
                cine_id: null,
                selectedCinemasList: [],
                md_id: null,
                selectedMoviesList: [],
                voucher_start_date_time: Records.voucher_start_date_time, // Start_Date,
                voucher_end_date_time: Records.voucher_end_date_time, // End_date,
                voucher_terms: Records.voucher_terms || null,
                voucher_is_active: Records.voucher_is_active || "Y",
                voucher_redemption_percent_fnb:
                  Records.voucher_redemption_percent_fnb,
                startTime2: moment(
                  Records.voucher_start_time,
                  "HH:mm:ss"
                ).format("HH:mm"),
                endTime2: moment(Records.voucher_end_time, "HH:mm:ss").format(
                  "HH:mm"
                ),
                selectedCinemaComplimentory: "",
                selectedScreen: "",
                cinema_id: Records.cinema_id,
                screen_id: Records.screen_id,
                voucher_for_specific_seat_type:
                  Records.voucher_for_specific_seat_type,
              };

              if (Records.voucher_is_active == "Y") {
                data.voucherCinemas = data.voucherCinemas.filter(
                  (x) => x.pvcs_is_active == "Y"
                );
              }

              if (Records.tt_id) {
                this.vouchersObject[
                  "ticket_type_selected"
                ] = this.TicketTypes.find((x) => x.tt_id == Records.tt_id);
              } else {
                this.vouchersObject["ticket_type_selected"] = "";
              }

              this.getCinemasList(data.voucherCinemas, Records.cinema_id);
              this.getActiveMovies(data.voucherMovies);
              this.setDaysValue(data.voucherDays);

              this.applicableFor = {
                prebook:
                  Records.vs_applicable_for_prebook === "Y" ? true : false,
                normal: Records.vs_applicable_for_normal === "Y" ? true : false,
              };
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    setDaysValue: function(voucherDays) {
      let days = {
        sunday: "pvds_sunday",
        monday: "pvds_monday",
        tuesday: "pvds_tuesday",
        wednesday: "pvds_wednesday",
        thursday: "pvds_thursday",
        friday: "pvds_friday",
        saturday: "pvds_saturday",
      };
      console.log("voucherDays :>> ", voucherDays);
      if (voucherDays && voucherDays.length > 0) {
        Object.keys(days).map((x) => {
          this.weekDays[x] = voucherDays[0][days[x]] === "Y" ? true : false;
        });

        let array = Object.keys(this.weekDays).filter(
          (x) => x !== "Alldays" && !this.weekDays[x]
        );
        if (array.length === 0) {
          this.weekDays["Alldays"] = true;
        }
      }
    },
    setVoucherConfiguration: function(Records) {
      this.isValueVoucher = Records.is_voucher_type_value || "Y";
      this.vouchersConfiguration = {
        vs_redeem_at_boxoffice:
          Records.vs_redeem_at_boxoffice === "Y" ? true : false,
        vs_redeem_at_concession:
          Records.vs_redeem_at_concession === "Y" ? true : false,
        vs_redeem_at_online: Records.vs_redeem_at_online === "Y" ? true : false,

        voucherPartnerName: Records.vp_partner_name,
        vp_id: Records.vp_id,
        noOfVoucher: null,
        amount: null,
        redemptionStartDateTime: null,
        redemptionEndDateTime: null,

        voucher_amount: Records.voucher_amount || null,
        voucher_is_percentage: Records.voucher_is_percentage || "Y",
        voucher_buy_no_of_ticket: Records.voucher_buy_no_of_ticket,
        voucher_get_free_ticket: Records.voucher_get_free_ticket,
        voucher_min_redemption_amount:
          Records.voucher_min_redemption_amount || 0,
        voucher_max_redemption_amount:
          Records.voucher_max_redemption_amount || null,
        voucherRedeemAmount: null,
        voucher_redemption_per_patron:
          Records.voucher_redemption_per_patron || null,
        voucher_total_redemption: Records.voucher_total_redemption || null,
      };
      if (
        Records.voucher_redeem_on_net &&
        Records.voucher_redeem_on_net === "Y"
      ) {
        this.vouchersConfiguration.voucherRedeemAmount =
          "voucherRedeemNetAmount";
      } else if (
        Records.voucher_redeem_on_gross &&
        Records.voucher_redeem_on_gross === "Y"
      ) {
        this.vouchersConfiguration.voucherRedeemAmount =
          "voucherRedeemGrossAmount";
      }
      if (Records.client_id) {
        this.setClientName(Records.client_id);
      }
    },
    setClientName: function(client_id) {
      ClientService.GetSingleClientDetails({ client_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.vouchersObject.selectedClient = obj;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onChangeWeekdays: function(event, keyname) {
      this.weekdayerror = "";
      // console.log("event :", event);
      if (keyname !== "Alldays") {
        this.weekDays["Alldays"] = false;
      }
      let len = Object.keys(this.weekDays).length;
      if (keyname === "Alldays" && event) {
        Object.keys(this.weekDays).map((x) => {
          x !== "Alldays" ? (this.weekDays[x] = true) : "";
        });
      } else if (keyname === "Alldays" && !event) {
        Object.keys(this.weekDays).map((x) => {
          x !== "Alldays" ? (this.weekDays[x] = false) : "";
        });
      } else if (keyname !== "Alldays" && this.weekDays.Alldays) {
        this.weekDays["Alldays"] = false;
      }
    },
    onChangeApplicable: function(event, keyname) {
      this.applicableerror = "";
      // if (keyname !== "all") {
      //   this.applicableFor["all"] = false;
      // }
      // let len = Object.keys(this.applicableFor).length;
      // if (keyname === "all" && event) {
      //   Object.keys(this.applicableFor).map(x => {
      //     x !== "all" ? (this.applicableFor[x] = true) : "";
      //   });
      // } else if (keyname === "all" && !event) {
      //   Object.keys(this.applicableFor).map(x => {
      //     x !== "all" ? (this.applicableFor[x] = false) : "";
      //   });
      // } else if (keyname !== "all" && this.applicableFor.all) {
      //   this.applicableFor["all"] = false;
      // }
    },
    onChangeReedem: function() {
      this.reedemerror = "";
    },
    onChangeSwitch: function(event) {
      if (event == "Y") {
        this.vouchersConfiguration.voucher_buy_no_of_ticket = null;
        this.vouchersConfiguration.voucher_get_free_ticket = null;
      } else if (event == "N") {
        this.vouchersConfiguration.voucher_amount = null;
        this.vouchersConfiguration.vs_redeem_at_concession = false;
      }
    },
    onSelectClient: function(client) {
      this.vouchersObject.client_id = client.client_id;
      this.vouchersObject.selectedClient = client;
      this.$forceUpdate();
    },
    getCinemasList: function(cinemasList, cinemaID = null, Indexx = null) {
      this.cinemasList = [];
      let cinemas = [];
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              data.Records.forEach((cine) => {
                cine["screen_id"] = null;
                cine["sst_id"] = null;
                cine["tt_id"] = null;
                cine["screenList"] = [];
                cine["seatClassList"] = [];
              });
              this.cinemasList = data.Records;
              this.Cinemas = data.Records;
              if (
                this.vouchersObject.voucher_for_specific_seat_type == "Y" &&
                cinemasList &&
                cinemasList.length > 0
              ) {
                cinemasList.forEach((SingleCinema, SingleCinemaIndex) => {
                  let tempObj = {
                    cine_id: SingleCinema.cinema_id,
                    screen_id: SingleCinema.screen_id || null,
                    sst_id: SingleCinema.seat_type_id || null,
                    tt_id: SingleCinema.tt_id || null,
                    screenList: [],
                    seatClassList: [],
                  };
                  this.vouchersObject.selectedCinemasList.push(tempObj);
                  this.getScreenList(
                    SingleCinema.cinema_id,
                    SingleCinema.screen_id,
                    SingleCinemaIndex,
                    true
                  );
                  this.getSeatClassList(
                    SingleCinema.screen_id,
                    SingleCinemaIndex,
                    true,
                    SingleCinema.seat_type_id
                  );
                });
              } else if (cinemasList && cinemasList.length > 0) {
                this.cinemasList.map((x) => {
                  let findIndex = cinemasList.findIndex(
                    (z) => z.cinema_id === x.cine_id
                  );
                  findIndex !== -1
                    ? this.vouchersObject.selectedCinemasList.push(x)
                    : "";
                });
              }
              if (cinemaID) {
                this.vouchersObject.cinema_id = cinemaID;
                this.vouchersObject.selectedCinemaComplimentory = data.Records.find(
                  (x) => x.cine_id == cinemaID
                );
                this.getScreenList(
                  cinemaID,
                  this.vouchersObject.screen_id,
                  Indexx
                );
              }
              this.cinemasList = [
                {
                  label: "Select All Cinemas",
                  Cinemas: data.Records,
                },
              ];
            }
          } else {
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    getClientList() {
      ClientService.GetAllClients({})
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.clientList = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getActiveMovies: function(movieList) {
      this.movieList = [];
      MovieService.GetActiveMoviesWithFormat({ movieversions: "Y" })
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.movieList = data.Records;
              if (movieList && movieList.length > 0) {
                this.movieList.map((x) => {
                  let findIndex = movieList.findIndex(
                    (z) => x.md_id === z.movie_detail_id
                  );
                  findIndex !== -1
                    ? this.vouchersObject.selectedMoviesList.push(x)
                    : "";
                });
              }

              this.onMountGotMovies = this.vouchersObject.selectedMoviesList;

              this.movieList = [
                {
                  label: "Select All Movies",
                  Movies: data.Records,
                },
              ];
            }
          } else {
            // Show Error Message
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    getActiveVoucherPartners: function() {
      this.voucherPartnerList = [];
      MarketingService.GetVoucherPartners()
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            data.Records.length > 0
              ? (this.voucherPartnerList = data.Records)
              : "";
          } else {
            // Show Error Message
            this.$toasted.show(data.message || this.AdminError);
          }
        })
        .catch(this._CatchError);
    },
    convertTime(date, time) {
      // const d = moment(date).format("L");
      const d = moment(date).format("YYYY-MM-DD");
      const newdate = moment(d + " " + time).format();
      return newdate;
    },
    OnFinalSubmit: function() {
      // console.log("this.weekDays :", this.weekDays);
      this.submitted = true;
      console.log("col-12 mt-4 text-center22222232");

      if (
        !this.weekDays.Alldays &&
        Object.keys(this.weekDays).filter(
          (x) => x !== "Alldays" && this.weekDays[x]
        ).length === 0
      ) {
        this.weekdayerror = "weekdaymsg";
        console.log("asfsafasfdasd");
      } else if (
        this.vouchersObject.share_is_percentage == "Y" &&
        this.vouchersObject.share_value > 100
      ) {
        return this.$toasted.show("Share value can not be more than 100");
      } else {
        this.weekdayerror = "";
        if (
          this.vouchersConfiguration.vs_redeem_at_boxoffice === false &&
          this.vouchersConfiguration.vs_redeem_at_concession === false &&
          this.vouchersConfiguration.vs_redeem_at_online === false
        ) {
          console.log("asfsafasfdasddasdasdasdas");

          this.reedemerror = "redeematmsg";
        } else {
          console.log("dasdasdasdasdasdasd", this.applicableFor);
          this.reedemerror = "";
          // if (
          //   (!this.applicableFor.all &&
          //     Object.keys(this.applicableFor).filter(
          //       x => x !== "all" && this.applicableFor[x]
          //     ).length === 0) ||
          //   false
          // ) {
          if (false) {
            console.log("dasdasdasdasdas23344");

            this.applicableerror = "applicablemsg";
          } else {
            this.applicableerror = "";
            console.log("dasdasdasdasdas");
            this.removedMovies.map((x, index) => {
              this.onMountGotMovies.filter((y) => {
                if (x.movie_id != y.movie_id) {
                  this.removedMovies.splice(index, 1);
                }
              });
            });

            console.log("col-12 mt-4 text-center22223332111111");

            this.$validator.validate().then((valid) => {
              // this.vouchersObject.selectedMoviesList.length == 0 ||

              let cinemaCheck = 0;

              if (this.vouchersObject.selectedCinemasList.length == 0) {
                cinemaCheck++;
              } else {
                this.vouchersObject.selectedCinemasList.forEach((x) => {
                  if (!x.cine_id) {
                    cinemaCheck++;
                  }
                });
              }

              if (cinemaCheck > 0) {
                return this.$toasted.show("Please Select Cinema");
              }
              if (
                this.isValueVoucher == "N" &&
                this.showConfiguration &&
                this.vouchersConfiguration.voucher_max_redemption_amount <
                  this.vouchersConfiguration.voucher_get_free_ticket
              ) {
                return this.$toasted.show(
                  "Maximum free tickets must be greater or equals to offer free tickets"
                );
              }
              if (
                this.vouchersObject.is_complimentary_ticket == "Y" &&
                !this.vouchersObject.ticket_type_selected
              ) {
                return;
              }
              console.log(valid, "col-12 mt-4 text-center");
              if (valid) {
                if (!this.vouchersObject.voucher_start_date_time) {
                  return this.$toasted.show("Please Enter Start Date");
                } else if (
                  !this.vouchersObject.voucher_end_date_time &&
                  false
                ) {
                  return this.$toasted.show("Please Enter End Date");
                } else if (
                  new Date(
                    moment(this.vouchersObject.voucher_end_date_time).format(
                      "YYYY-MM-DD"
                    )
                  ) &&
                  new Date(
                    moment(this.vouchersObject.voucher_start_date_time).format(
                      "YYYY-MM-DD"
                    )
                  ) >
                    new Date(
                      moment(this.vouchersObject.voucher_end_date_time).format(
                        "YYYY-MM-DD"
                      )
                    )
                ) {
                  return this.$toasted.show(
                    "From date should not be greater than To date."
                  );
                } else {
                  if (
                    this.vouchersObject.startTime2 &&
                    this.vouchersObject.endTime2
                  ) {
                    this.vouchersObject.voucher_start_date_time = this.convertTime(
                      this.vouchersObject.voucher_start_date_time,
                      this.vouchersObject.startTime2
                    );
                    if (this.vouchersObject.voucher_end_date_time) {
                      this.vouchersObject.voucher_end_date_time = this.convertTime(
                        this.vouchersObject.voucher_end_date_time,
                        this.vouchersObject.endTime2
                      );
                    }
                  }
                }

                let loader = this.$loading.show();
                console.log("this.vouchersObject :>> ", this.vouchersObject);
                if (
                  this.vouchersObject["is_open_voucher"] == "Y" &&
                  this.vouchersObject["is_complimentary_ticket"] == "N"
                ) {
                } else {
                  this.vouchersObject["is_allow_cash_refund"] = "N";
                }
                let payload = {
                  isValueVoucher: this.isValueVoucher,
                  voucherid: this.vouchersObject.voucher_id,
                  ...this.vouchersObject,
                  vouchersConfiguration: this.vouchersConfiguration,
                  ...this.vouchersConfiguration,
                  weekDays: this.weekDays,
                  ...this.applicableFor,
                  removedMovies: this.removedMovies,
                };
                if (!payload.voucherid) {
                  payload.voucherid = this.voucher_id;
                  payload.voucher_id = this.voucher_id;
                }
                MarketingService.UpdateVoucher(payload)
                  .then((response) => {
                    const { data } = response;
                    if (data && data.status) {
                      // data.Records.length > 0
                      this.$toasted.show(
                        data.message || "Voucher updated successfully"
                      );
                      this.$router.push({
                        path: "/marketing/vouchers",
                      });
                    } else {
                      // Show Error Message
                      this.$toasted.show(data.message || this.AdminError);
                    }
                  })
                  .catch(this._CatchError)
                  .finally(() => {
                    setTimeout(() => loader.hide(), 1000);
                  });
              }
            });
          }
        }
      }
    },
    // SAIF
  },
};
</script>
<style>
.custom-date .btn-clearDate {
  right: 30px !important;
}
.customDisabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.new-border {
  border: 2px solid #b1b4b8;
}
label {
  color: black !important;
}
.internal-border {
  border: 1px solid #3876d2;
  /*background-color: #e6e6f8;*/
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;
  margin: 0 15px 15px 15px;
  padding-top: 15px;
}
.back {
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/VouchersComponent/editVouchers.vue